<template>
  <div class="network-status-bar">
    <p v-if="isOnline === false" class="alert alert-danger">
      <b>Netwerk probleem</b>
      <br>
      Het lijkt erop dat je geen internetverbinding hebt.
      Gegevens zijn mogelijk niet actueel en eventuele wijzigen worden niet opgeslagen.
    </p>
  </div>
</template>

<script>
export default {
  name: 'network-status-bar',
  data () {
    return {
      isOnline: false
    }
  },
  created () {
    var app = this
    app.updateStatus()
    if (this.getApplicationSetting('ipad_network_status_check_method') === 'websockets') {
      // eslint-disable-next-line no-undef
      var pusher = new Pusher('3a33d6fc8136b737c364', {
        cluster: 'eu',
        activityTimeout: 3000,
        pongTimeout: 500,
        unavailableTimeout: 1000
      });

      pusher.connection.bind('state_change', function (states) {
        app.updateStatusWebSockets(states.current === 'connected');
      });


      var channel = pusher.subscribe('my-channel');
      channel.bind('my-event', function(data) {
        app.messages.push(JSON.stringify(data));
      });
    } else {
      window.addEventListener('online', app.updateStatus)
      window.addEventListener('offline', app.updateStatus)
    }
  },
  methods: {
    updateStatus () {
      if (typeof window.navigator.onLine === 'undefined') {
        // If the browser doesn't support connection status reports
        // assume that we are online
        this.isOnline = true
      } else {
        this.isOnline = window.navigator.onLine
      }
    },
    updateStatusWebSockets(online) {
      if (online) {
        this.isOnline = true;
      } else {
        this.isOnline = false
      }
    }
  }
}
</script>

<style scoped>
    .alert {
        margin: 0;
    }
</style>
